<template>
  <div class="login--root">
    <div class="contain">
      
      <div class="login--body">
        <div class="login--header">
          <h1 class="login--title">Login</h1>
          <p class="login--desc">
            Welcome back! Log in to your account.
          </p>
        </div>

        <form class="ui form login--form">
          <div class="field">
            <label>Email</label>
            <input type="text" v-model="email" placeholder="Email">
          </div>
          <div class="field" :class="{ error: errors.pass }">
            <label>Password</label>
            <input type="password" v-model="pass" placeholder="Password" required>
            <div class="ui red pointing label" v-if="errors.pass">{{ errors.pass }}</div>
          </div>
          <div class="sc--btn--group">
            <button href="#!" class="sc--btn" type="submit" @click.prevent="submitForm">
              Sign in
            </button>
          </div>
        </form>
        <div class="ui error message transition" v-show="formValidate">
          <i class="close icon" @click="formValidate = false"></i>
          <div class="header">
            {{ errors.formResponse  }} <br>
            There were some errors with your submission
          </div>
          <ul class="list">
            <li>check your email.</li>
            <li>check your password.</li>
          </ul>
        </div>
        <div class="register--text">
          <p>
            Don't have an account?
          </p>
          <router-link to="/register">Sign up</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import jQuery from 'jquery';
export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      pass: '',
      errors: {
        email: '',
        pass: '',
        formResponse: ''
      },
      formValidate: false,
    }
  },
  methods: {
    getBearerToken() {
      fetch('/wp-json/simple-jwt-authentication/v1/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: this.email,
          password: this.pass
        })
      }).then(response => response.json())
        .then(data => {
          console.log(data);
          localStorage.setItem('sjdifjsckdsjfosdf54520bearer', data.token);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
    async submitForm() {
      this.validateForm();
      this.getBearerToken();
      if (this.formIsValid()) {
        try {
          const response = await fetch('/wp-json/custom/v1/login', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              username: this.email,
              password: this.pass
            })
          });

          const responseData = await response.json();

          if (response.ok && responseData.success) {
            // Authentication successful
            console.log('User logged in:', responseData);
            // Store the token securely (e.g., in an HTTP-only cookie)
            // document.cookie = `authToken=${responseData.token}; Secure; SameSite=None; HttpOnly`;
            localStorage.setItem('sjdifjsckdsjfosdf54520yyy', responseData.token);
            localStorage.setItem('sjdifjsckdsjfosdf54520zzz', parseInt(responseData.id));
            localStorage.setItem('sjdifjsckdsjfosdf54520base', responseData.base64_token);


            // Redirect or perform other actions for authenticated users
            // redirect window to login page
            this.$router.push('/dashboard');
          } else {
            // Authentication failed
            console.error('Authentication failed:', responseData);
            this.formValidate = true;
            this.errors.formResponse = responseData.message;
          }
        } catch (error) {
          console.error('An error occurred:', error);
        }
      }
    },
    validateForm() {
      this.errors.pass = this.pass ? '' : 'Please enter a password';
      if (this.pass && this.pass.length < 6) {
        this.errors.pass = 'Your password must be at least 6 characters';
      }
    },
    formIsValid() {
      return !this.errors.email && !this.errors.pass;
    }
  }
}


</script>

<style lang="sass">

  @import '../assets/css/public'

  .login--root
    .contain
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column

      .login--body
        width: 450px
        max-width: 100%
        margin-top: 50px

      .login--form
        background: $light-gray
        padding: 50px
        margin-top: 50px
        +lines-border(5px)

        input
          border: 1px solid $black

        label
          font-size: 16px
          color: $sec-purple
          margin-bottom: 7px

        .sc--btn
          margin-top: 20px

      .login--header

        .login--title
          font-size: 40px
          margin-bottom: 10px
          color: $black

        .login--desc
          font-size: 16px
          color: $text-gray

      .register--text
        display: flex
        align-items: center
        justify-content: flex-start
        flex-wrap: wrap
        margin-top: 20px
        
        p
          font-size: 16px
          color: $text-gray
          margin-bottom: 0
          margin-right: 10px

        a
          font-family: PP-Medium
          font-size: 16px
</style>